import CmsModules from "theme/libs/wordpress/content/CmsModules";
import PageWrapper from "theme/components/wrappers/PageWrapper";
import PropTypes from "prop-types";
import React from "react";
import { useTranslation } from "react-i18next";

const Default = ({ data }) => {
    const { t } = useTranslation();
    const { hero_content: heroContent, page_content: pageContent, title } = data;

    const breadcrumbs = [{ permalink: "/", title: t("breadcrumbs.home") }];

    if (data.breadcrumbs?.length) {
        breadcrumbs.push(...data.breadcrumbs);
    }

    breadcrumbs.push({ permalink: null, title });

    return (
        <PageWrapper isUnderneathNavbar={!!heroContent}>
            <CmsModules
                isHero
                data={
                    heroContent && Array.isArray(heroContent) && heroContent.length > 0
                        ? heroContent[0]
                        : { layout: "hero_placeholder" }
                }
                breadcrumbs={breadcrumbs}
            />
            <CmsModules data={pageContent} />
        </PageWrapper>
    );
};

Default.propTypes = {
    data: PropTypes.shape({
        breadcrumbs: PropTypes.array.isRequired,
        hero_content: PropTypes.oneOfType([PropTypes.array, PropTypes.bool]).isRequired,
        page_content: PropTypes.array.isRequired,
        title: PropTypes.string.isRequired,
    }).isRequired,
};

export default Default;
